import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-twitter.svg";
import * as styles from "./Icon.module.scss";

type TwitterProps = React.SVGProps<SVGSVGElement>;

export const Twitter = ({ className, ...props }: TwitterProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
